import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Megaphone } from "@phosphor-icons/react";

export default function ParentAnnouncements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/parent/announcements").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="overline">Broadcast</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tight mt-1">News</h1>
      </div>
      {items.length === 0 ? (
        <div className="bg-[#121212] border border-neutral-800 rounded-lg p-10 text-center overline">No announcements yet</div>
      ) : (
        <div className="space-y-4">
          {items.map((a) => (
            <div key={a.id} className="bg-[#121212] border border-neutral-800 rounded-lg p-5">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-md bg-[#D90429] flex items-center justify-center shrink-0">
                  <Megaphone size={20} weight="fill" color="#fff" />
                </div>
                <div>
                  <div className="font-display font-black text-xl uppercase tracking-tight">{a.title}</div>
                  <div className="overline mt-1">{a.author_name} • {new Date(a.created_at).toLocaleDateString()}</div>
                </div>
              </div>
              <div className="mt-4 text-sm text-neutral-300 whitespace-pre-wrap">{a.message}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
